import React from 'react';
import { createRoot } from 'react-dom/client';

// Cache the created roots per target node so repeated renders reuse the same
// root instead of calling createRoot twice on the same container (which React
// 18 warns against).
const roots = new WeakMap();

/**
 * Render a simple react component to the given selector.
 * TODO: Add styled-components theme, redux, etc., when needed.
 *
 * @method renderComponent
 * @param  {Component}       Component The component to render
 * @param  {Object}          props     The properties to pass to the rendered Component
 * @param  {string}          selector  The ID selector used to find the DOM node for the Component
 */
const renderComponent = (Component, props, selector) => {
    // The target can be a string, in that case we will use the
    // `document.getElementById()` to grab it, otherwise if
    // the use passed in an actual DOM node then use that node.
    const target = typeof selector === 'string' ? document.getElementById(selector) : selector;
    // Reuse an existing root for this target if one exists.
    let root = roots.get(target);
    if (!root) {
        root = createRoot(target);
        roots.set(target, root);
    }
    // Render the requested component.
    root.render(<Component {...props} />);
};

export default renderComponent;
